<template>
	<div class="xs-12">
		<j-base-select
			:size="size"
			:allowSelectNothing="false"
			:options="options"
			:value="value"
			@input="$emit('input', $event)"
		/>
	</div>
</template>

<script>
import JBaseSelect from "@/components/JBaseSelect"
export default {
	name: "CoreSelectLocale",

	components: { JBaseSelect },

	props: {
		value: {
			validator(value) {
				return value === null || typeof value === "string"
			},
			required: true
		},
		size: {
			type: String,
			required: false,
			default: "medium"
		}
	},

	computed: {
		options() {
			const allowedLocales = this.$store.state.settings?.allowedLocales || [
					this.$store.state.settings?.locale
				] || ["en-US"]

			return allowedLocales.map(code => {
				return {
					value: code,
					name:
						code === "en-US"
							? "English"
							: code === "zh-HK"
							? "繁體中文"
							: code === "zh-CN"
							? "简体中文"
							: code
				}
			})
		}
	}
}
</script>
